
























































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient from "@/apollo";
import gql from "graphql-tag";
import LabelSelector from "@/components/LabelSelector.vue";
import InfiniteLoading from "vue-infinite-loading";
import { contextModule } from "@/store/context";
import ImageCard from "@/components/ImageCard.vue";
import Lightbox from "@/components/Lightbox.vue";
import actorFragment from "@/fragments/actor";
import imageFragment from "@/fragments/image";
import ImageUploader from "@/components/ImageUploader.vue";
import IImage from "@/types/image";
import ILabel from "@/types/label";
import DrawerMixin from "@/mixins/drawer";
import { mixins } from "vue-class-component";
import { imageModule } from "@/store/image";

@Component({
  components: {
    LabelSelector,
    InfiniteLoading,
    ImageCard,
    Lightbox,
    ImageUploader,
  },
})
export default class ImageList extends mixins(DrawerMixin) {
  addNewItem(image: IImage) {
    this.images.unshift(image);
  }

  get showSidenav() {
    return contextModule.showSidenav;
  }

  rerollSeed() {
    const seed = Math.random().toString(36);
    localStorage.setItem("pm_seed", seed);
    if (this.sortBy === "$shuffle") this.loadPage(this.page);
    return seed;
  }

  images = [] as IImage[];

  fetchLoader = false;
  fetchError = false;
  fetchingRandom = false;

  lightboxIndex = null as number | null;

  tryReadLabelsFromLocalStorage(key: string) {
    return (localStorage.getItem(key) || "").split(",").filter(Boolean) as string[];
  }

  allLabels = [] as ILabel[];
  selectedLabels = {
    include: this.tryReadLabelsFromLocalStorage("pm_imageInclude"),
    exclude: this.tryReadLabelsFromLocalStorage("pm_imageExclude"),
  };

  onSelectedLabelsChange(val: any) {
    localStorage.setItem("pm_imageInclude", val.include.join(","));
    localStorage.setItem("pm_imageExclude", val.exclude.join(","));
    this.refreshed = false;
  }

  // largeThumbs = localStorage.getItem("pm_imageLargeThumbs") == "true" || false;

  query = localStorage.getItem("pm_imageQuery") || "";

  set page(page: number) {
    imageModule.setPage(page);
  }

  get page() {
    return imageModule.page;
  }

  get numResults() {
    return imageModule.numResults;
  }

  get numPages() {
    return imageModule.numPages;
  }

  sortDir = localStorage.getItem("pm_imageSortDir") || "desc";
  sortDirItems = [
    {
      text: "Ascending",
      value: "asc",
    },
    {
      text: "Descending",
      value: "desc",
    },
  ];

  sortBy = localStorage.getItem("pm_imageSortBy") || "relevance";
  sortByItems = [
    {
      text: "Relevance",
      value: "relevance",
    },
    {
      text: "A-Z",
      value: "name",
    },
    {
      text: "Added to collection",
      value: "addedOn",
    },
    {
      text: "Rating",
      value: "rating",
    },
    {
      text: "Bookmarked",
      value: "bookmark",
    },
    {
      text: "Random",
      value: "$shuffle",
    },
  ];

  favoritesOnly = localStorage.getItem("pm_imageFavorite") == "true";
  bookmarksOnly = localStorage.getItem("pm_imageBookmark") == "true";
  ratingFilter = parseInt(localStorage.getItem("pm_imageRating") || "0");

  uploadDialog = false;
  isUploading = false;

  selectedImages = [] as string[];
  lastSelectionImageId: string | null = null;
  deleteSelectedImagesDialog = false;

  isImageSelected(id: string) {
    return !!this.selectedImages.find((selectedId) => id === selectedId);
  }

  selectImage(id: string, add: boolean) {
    this.lastSelectionImageId = id;
    if (add && !this.isImageSelected(id)) {
      this.selectedImages.push(id);
    } else {
      this.selectedImages = this.selectedImages.filter((i) => i != id);
    }
  }

  /**
   * @param image - the clicked image
   * @param index - the index of the image in the array
   * @param event - the mouse click event
   * @param forceSelectionChange - whether to force a selection change, instead of opening the image
   */
  onImageClick(image: IImage, index: number, event: MouseEvent, forceSelectionChange = true) {
    // Use the last selected image or the current one, to allow toggling
    // even when no previous selection
    let lastSelectionImageIndex =
      this.lastSelectionImageId !== null
        ? this.images.findIndex((im) => im._id === this.lastSelectionImageId)
        : index;
    lastSelectionImageIndex = lastSelectionImageIndex === -1 ? index : lastSelectionImageIndex;

    if (event.shiftKey) {
      // Next state is opposite of the clicked image state
      const nextSelectionState = !this.isImageSelected(image._id);

      // Use >= to include the currently clicked image, so it can be toggled
      // if necessary
      if (index >= lastSelectionImageIndex) {
        for (let i = lastSelectionImageIndex + 1; i <= index; i++) {
          this.selectImage(this.images[i]._id, nextSelectionState);
        }
      } else if (index < lastSelectionImageIndex) {
        for (let i = lastSelectionImageIndex; i >= index; i--) {
          this.selectImage(this.images[i]._id, nextSelectionState);
        }
      }
    } else if (forceSelectionChange || event.ctrlKey) {
      this.selectImage(image._id, !this.isImageSelected(image._id));
    } else if (!forceSelectionChange) {
      this.lightboxIndex = index;
    }
  }

  deleteSelection() {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeImages(ids: $ids)
        }
      `,
      variables: {
        ids: this.selectedImages,
      },
    })
      .then((res) => {
        for (const id of this.selectedImages) {
          this.images = this.images.filter((img) => img._id != id);
        }
        this.selectedImages = [];
        this.deleteSelectedImagesDialog = false;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  }

  removeImage(index: number) {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeImages(ids: $ids)
        }
      `,
      variables: {
        ids: [this.images[index]._id],
      },
    })
      .then((res) => {
        this.images.splice(index, 1);
        this.lightboxIndex = null;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  }

  updateImage({ index, key, value }: { index: number; key: string; value: any }) {
    const images = this.images[index];
    images[key] = value;
    Vue.set(this.images, index, images);
  }

  openUploadDialog() {
    this.uploadDialog = true;
  }

  refreshed = true;

  resetPagination() {
    imageModule.resetPagination();
    this.refreshed = true;
    this.loadPage(this.page).catch(() => {
      this.refreshed = false;
    });
  }

  @Watch("ratingFilter", {})
  onRatingChange(newVal: number) {
    localStorage.setItem("pm_imageRating", newVal.toString());
    this.refreshed = false;
  }

  @Watch("favoritesOnly")
  onFavoriteChange(newVal: boolean) {
    localStorage.setItem("pm_imageFavorite", "" + newVal);
    this.refreshed = false;
  }

  @Watch("bookmarksOnly")
  onBookmarkChange(newVal: boolean) {
    localStorage.setItem("pm_imageBookmark", "" + newVal);
    this.refreshed = false;
  }

  @Watch("sortDir")
  onSortDirChange(newVal: string) {
    localStorage.setItem("pm_imageSortDir", newVal);
    this.refreshed = false;
  }

  @Watch("sortBy")
  onSortChange(newVal: string) {
    localStorage.setItem("pm_imageSortBy", newVal);
    this.refreshed = false;
  }

  @Watch("selectedLabels")
  onLabelChange() {
    this.refreshed = false;
  }

  @Watch("query")
  onQueryChange(newVal: string | null) {
    localStorage.setItem("pm_imageQuery", newVal || "");
    this.refreshed = false;
  }

  async fetchPage(page: number, take = 24, random?: boolean, seed?: string) {
    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: ImageSearchQuery!, $seed: String) {
            getImages(query: $query, seed: $seed) {
              numItems
              numPages
              items {
                ...ImageFragment
                labels {
                  _id
                  name
                }
                studio {
                  _id
                  name
                }
                actors {
                  ...ActorFragment
                  avatar {
                    _id
                    color
                  }
                }
                scene {
                  _id
                  name
                  thumbnail {
                    _id
                  }
                }
              }
            }
          }
          ${imageFragment}
          ${actorFragment}
        `,
        variables: {
          query: {
            include: this.selectedLabels.include,
            exclude: this.selectedLabels.exclude,
            query: this.query || "",
            take,
            page: page - 1,
            sortDir: this.sortDir,
            sortBy: random ? "$shuffle" : this.sortBy,
            favorite: this.favoritesOnly,
            bookmark: this.bookmarksOnly,
            rating: this.ratingFilter,
          },
          seed: seed || localStorage.getItem("pm_seed") || "default",
        },
      });

      return result.data.getImages;
    } catch (err) {
      throw err;
    }
  }

  labelAliases(label: any) {
    return label.aliases.slice().sort().join(", ");
  }

  loadPage(page: number) {
    this.fetchLoader = true;
    this.selectedImages = [];

    return this.fetchPage(page)
      .then((result) => {
        this.fetchError = false;
        imageModule.setPagination({
          numResults: result.numItems,
          numPages: result.numPages,
        });
        this.images = result.items;
      })
      .catch((err) => {
        console.error(err);
        this.fetchError = true;
      })
      .finally(() => {
        this.fetchLoader = false;
      });
  }

  refreshPage() {
    this.loadPage(imageModule.page);
  }

  mounted() {
    if (!this.images.length) this.refreshPage();
  }

  beforeMount() {
    ApolloClient.query({
      query: gql`
        {
          getLabels {
            _id
            name
          }
        }
      `,
    })
      .then((res) => {
        this.allLabels = res.data.getLabels;
        if (!this.allLabels.length) {
          this.selectedLabels.include = [];
          this.selectedLabels.exclude = [];
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
